<template>
  <div class="h-spinner" :class="size">
    <b-spinner variant="primary"></b-spinner>
  </div>
</template>

<script>
export default {
  name: "spinner",

  props : {
    size : {
      type : String,
      default : "md"
    },
  }
}
</script>

<style scoped>

</style>